<div class="flex-1 flex flex-col overflow-hidden">
  <!-- Account Settings Content -->
  <main class="flex-1 overflow-y-auto p-6">
    <!-- Page Title -->
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900">Account Settings</h1>
    </div>

    <!-- Account Settings Form -->
    <div class="max-w-2xl">
      <!-- Success Message -->
      @if (successMessage) {
      <div
        class="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-md"
      >
        {{ successMessage }}
      </div>
      }

      <!-- Error Message -->
      @if (errorMessage) {
      <div
        class="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-md"
      >
        {{ errorMessage }}
      </div>
      }

      <!-- Email Field -->
      <div class="mb-8">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Email
        </label>
        <div class="text-lg text-gray-900 font-medium">
          {{ currentUser?.email || "No email available" }}
        </div>
      </div>

      <!-- Password Field -->
      <div class="mb-8">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Password
        </label>
        <div class="flex items-center justify-between">
          <button
            (click)="onChangePassword()"
            class="underline px-4rounded-md text-lg font-medium cursor-pointer change-password"
          >
            Change Password
          </button>
        </div>
      </div>
    </div>
  </main>
</div>

<!-- Change Password Modal -->
<app-change-password-modal
  [(visible)]="showChangePasswordModal"
  (onSubmit)="onPasswordChangeSubmit($event)"
  [isLoading]="isLoading"
></app-change-password-modal>
